<script>
/* eslint-disable */
import {Loader} from '@googlemaps/js-api-loader'
import {
  checkRouteStatus,
  getGrvsPendentes,
  getUltimaLocalizacaoReboquista,
  saveRoute,
  snapToRoads
} from '../../../domain/callcenter/services'
import ContextMenu from '../../map/mixins/ContextMenu'
import Geocode from '../../map/mixins/Geocode'
import MapMarkerTooltip from "./MapMarkerTooltip";
import BtnListaReboquesMap from "./btn-lista-reboques-map/BtnListaReboquesMap";
import ListaReboquesMap from "./btn-lista-reboques-map/ListaReboquesMap";

let numDeltas = 100;
let delay = 10; //milliseconds
let transitionIndex = 0;
let deltaLat;
let deltaLng;

export default {
  name: 'CallCenterMap',
  components: {ListaReboquesMap, BtnListaReboquesMap, MapMarkerTooltip},
  props: ['reboques'],
  mixins: [ContextMenu, Geocode],
  data () {
    return {
      apiKey: 'AIzaSyDOSOhYdt1eYdix6HnWNujnrturXzszatI',
      mapOptions: {
        zoom: 8,
        center: {lat: -20.420874, lng: -40.329344},
        mapId: 'AWESOME_MAP'
      },
      google: null,
      map: null,
      markers: null,
      places: [],
      currentPlace: null,
      snappedCoordinates: null,
      placeIdArray: null,
      polylines: [],
      reboquesDisponiveis: [],
      instanceIds: [], // Reboques instanciados com o Marker
      activeRoutes: [], // Rotas ativas
      openListaReboques: false
    };
  },
  async mounted () {
    this.geolocate();

    this.google = await new Loader({
      apiKey: this.apiKey,
      version: 'weekly',
      libraries: ['places', 'marker']
    })
    this.initializeMap()
    this.$intervalFocusMarker = setInterval(() => { // TODO: Temporário. Deve existir uma função ativa por uma prop para navegar automatico entre os pontos (markers)
      console.log('Pan to: ', this.reboquesDisponiveis)
      if (Array.isArray(this.reboquesDisponiveis) && this.reboquesDisponiveis.length === 1) {
        this.map.panTo(this.reboquesDisponiveis[0].marker.position)
      } else {
        this.adjustZoomToMarkers()
      }
    }, 120000)
  },
  destroyed () {
    clearInterval(this.$intervalFocusMarker)
    this.reboques.forEach(reboque => {
      const interval = this[`interval${reboque.id}`]
      if (!interval) return
      clearInterval(interval)
    })
    this.reboques.forEach(reboque => {
      const interval = this[`intervalGrvs${reboque.id}`]
      if (!interval) return
      clearInterval(interval)
    })
  },
  watch: {
    reboques () {
      setTimeout(() => {
        this.removeGhosts()
        this.loadReboques()
      }, 2000)
    }
  },
  methods: {
    initializeMap () {
      const mapContainer = this.$refs.googleMap

      this.google.load()
        .then(google => {
          this.google = google
          this.map = new google.maps.Map(mapContainer, this.mapOptions)

          this.google.maps.event.addListener(this.map, 'rightclick', (event) => {
            this.showContextMenu(event.latLng);
          })

          // Geocoder
          this.geocoder = new this.google.maps.Geocoder();

          // MaxZoom
          this.maxZoomService = new this.google.maps.MaxZoomService();

          // Direction
          this.directionsService = new this.google.maps.DirectionsService();
        })
        .catch(error => {
          console.log(error)
        })
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.$mePosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },

    runSnapToRoad (path) {
      const pathValues = [];
      for (let i = 0; i < path.length; i++) {
        const x = (path[i].lat.toFixed(6) + ',' + path[i].lng.toFixed(6));
        pathValues.push(x);
        console.log(x);
      }

      snapToRoads(this.apiKey, pathValues)
        .then((response) => {
          this.processSnapToRoadResponse(response.data)
          this.drawSnappedPolyline()
        })
        .catch((error) => {
          console.log(error)
        })
    },

    processSnapToRoadResponse (data) {
      this.snappedCoordinates = [];
      this.placeIdArray = [];
      for (let i = 0; i < data.snappedPoints.length; i++) {
        let latlng = new this.google.maps.LatLng(
          data.snappedPoints[i].location.latitude,
          data.snappedPoints[i].location.longitude);
        this.snappedCoordinates.push(latlng);
        this.placeIdArray.push(data.snappedPoints[i].placeId);
      }
    },

    drawSnappedPolyline () {
      let snappedPolyline = new this.google.maps.Polyline({
        path: this.snappedCoordinates,
        strokeColor: '#90c0f0',
        strokeWeight: 3
      });

      snappedPolyline.setMap(this.map);
      this.polylines.push(snappedPolyline);
    },

    loadReboques () {
      if (!Array.isArray(this.reboques) || this.reboques.length === 0) {
        return
      }

      let lastMarker

      this.reboques.forEach((reboque, index) => {
        /**
         * TODO: Verificar se reboque já está instanciado no mapa (Marker).
         * Isto pode ter erro se recarregar reboques e tentar instanciar um reboque
         * já instanciado, gerando duplicidade.
         */

        if (!reboque.ultimaLocalizacao) return

        const isReboqueJaInstanciado = this.reboquesDisponiveis.some(r => r.id === reboque.id)
        if (isReboqueJaInstanciado) return

        /* let ico = {
          url: 'https://www.logdep.com.br/static/reboque.svg',
          scaledSize: new this.google.maps.Size(50, 50),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(0, 0)
        }; */

        const marker = lastMarker = this.makeNewMarker(reboque)
        this.reboquesDisponiveis.push({...reboque, marker})

        const reboqueInstanciado = this.getReboqueInstanciado(reboque.id)
        this.iniciaCapturaDeLocalizacao(reboque)
        this.iniciaVerificacaoGrvsPendentes(reboque)
        this.$refs.mapTooltip.addListener(this.$refs.googleMap, marker, reboqueInstanciado)
      })

      if (this.reboques.length === 1) {
        this.focusOnTheSingleMarker(lastMarker)
      } else {
        this.adjustZoomToMarkers()
      }
    },

    makeNewMarker (reboque) {
      const {lat, lng} = reboque.ultimaLocalizacao
      const localizacao = {
        lat: Number(lat),
        lng: Number(lng)
      }

      const contentIcon = this.getIconeReboque(reboque)
      this.updateIconeReboque(reboque.disponivel || !reboque.grvs.length, contentIcon)
      const marker = new this.google.maps.marker.AdvancedMarkerElement({
        position: localizacao,
        map: this.map,
        content: contentIcon
      });
      marker.setMap(this.map);

      return marker
    },

    getReboqueInstanciado (id) {
      return this.reboquesDisponiveis.find(reboque => reboque.id === id)
    },

    getIconeReboque (reboque) {
      const divIcon = this.$refs[`icon${reboque.id}`]
      const customContent = Array.isArray(divIcon) ? divIcon[0] : divIcon
      customContent.classList.add('custom-marker')

      return customContent
    },

    updateIconeReboque (disponivel, {classList}) {
      const changeClass  = (classToRemove, classToAdd)  => {
        classList.contains(classToRemove) && classList.remove(classToRemove)
        !classList.contains(classToAdd) && classList.add(classToAdd)
      }

      if (disponivel) {
        changeClass('custom-marker-indisponivel', 'custom-marker-disponivel')
      } else {
        changeClass('custom-marker-disponivel', 'custom-marker-indisponivel')
      }
    },

    adjustZoomToMarkers() {
      const bounds = new this.google.maps.LatLngBounds();

      this.reboquesDisponiveis.forEach(({ marker }) => {
        bounds.extend(marker.position);
      });

      this.map.fitBounds(bounds);
    },

    iniciaCapturaDeLocalizacao (reboque) {
      let interval = this[`interval${reboque.id}`]
      if (interval) clearInterval(interval)

      console.log('ID: ', reboque.id, this.reboquesDisponiveis)
      this[`interval${reboque.id}`] = setInterval(() => {
        getUltimaLocalizacaoReboquista(reboque.id)
          .then(response => {
            let localizacao = {
              lat: Number(response.data.latitude),
              lng: Number(response.data.longitude)
            }
            const reboqueInstanciado = this.getReboqueInstanciado(reboque.id)
            if (reboqueInstanciado) {
              reboqueInstanciado.marker.position = new this.google.maps.LatLng(localizacao.lat, localizacao.lng)
              console.log('ÚLTIMA LOCALIZAÇÃO: ', response.data)
              reboque.localizacao = localizacao
              this.moveReboque(reboque)
            }
          })
      }, 10000)
    },

    iniciaVerificacaoGrvsPendentes (reboque) {
      let interval = this[`intervalGrvs${reboque.id}`]
      if (interval) clearInterval(interval)

      this[`intervalGrvs${reboque.id}`] = setInterval(() => {
        getGrvsPendentes(reboque.id)
          .then(response => {
            const reboqueInstanciado = this.getReboqueInstanciado(reboque.id)
            if (reboqueInstanciado) {
              reboqueInstanciado.grvs = response.data
                const content = this.getIconeReboque(reboque)
                this.updateIconeReboque(!response.data.length, content)
            }
          })
      }, 10000)
    },

    focusOnTheSingleMarker (marker) {
      this.maxZoomService.getMaxZoomAtLatLng(marker.position, (response) => {
        if (response.status !== 'OK') {
          this.map.setZoom(11)
        } else {
          this.map.setZoom(response.zoom - 5)
        }
        this.map.panTo(marker.position)
      });
      window.setTimeout(() => {
        this.map.panTo(marker.position)
      }, 1000)
    },

    moveReboque (reboque) {
      // let reboqueInstanciado = this.reboquesDisponiveis.filter(r => r.id === reboque.reboque)
      const reboqueInstanciado = this.getReboqueInstanciado(reboque.id)
      if (!reboqueInstanciado) {
        console.error('Impossível atualizar localização de reboque. Reboque não instanciado no mapa.')
        return
      }
      // reboqueInstanciado.marker.setPosition(reboque.localizacao)
      // reboqueInstanciado.marker.setMap(this.map)
      let origin = reboqueInstanciado.marker.position.toJSON()
      console.log('ORIGIN: ', origin)
      this.transition(origin, reboque.localizacao, reboqueInstanciado.marker)
      // this.map.panTo(reboqueInstanciado.marker.position) // Temporário
    },

    removeGhosts () {
      if (Array.isArray(this.reboquesDisponiveis) && this.reboquesDisponiveis.length > 0) {
        this.reboquesDisponiveis.forEach((reboque, index) => {
          if (reboque.working) {
            return
          }
          this.reboquesDisponiveis[index].marker.setMap(null)
          delete this.reboquesDisponiveis[index]
        })
      }
    },

    montaRotaAtendimento (solicitacao, origin, destiny, extras = null) {
      this.directionsService.route(
        {
          origin: origin,
          destination: destiny,
          travelMode: 'DRIVING'
        },
        (response, status) => {
          console.log(response, status)
          if (status === 'OK') {
            let route = {id: null, rota: response}
            saveRoute(solicitacao, {rota: response, tipo: 0, ativo: true})
              .then((response) => {
                console.log('Rota salva com sucesso')
                route.id = response.data.id
                this.renderRoute(route)
              })
              .catch((response) => {
                console.log(response.data)
                window.alert('Ocorreu algum problema ao salvar a rota, tente novamente, se o erro persistir, contate o administrador do sistema'); // TODO: Verificar/Implementar nova tentativa. Verificar melhor maneira
              })
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });

      /**
       * Tenta montar rotas complementares (DESTINATION até Patio)
       */
      if (extras && Array.isArray(extras)) {
        let _origin = origin
        extras.forEach((latLng, i) => {
          this.directionsService.route(
            {
              origin: _origin,
              destination: latLng,
              travelMode: 'DRIVING'
            },
            (response, status) => {
              if (status === 'OK') {
                // console.log(response)
                let route = {id: null, rota: response}
                saveRoute(solicitacao, {rota: response, tipo: i + 1, ativo: false})
                  .then((response) => {
                    console.log(`Rota complementar ${i + 1} salva com sucesso`)
                    route.id = response.data.id
                    // this.renderRoute(route)
                  })
                  .catch((response) => {
                    console.log(response.data)
                    window.alert('Ocorreu algum problema ao salvar a rota complementar (' + i + ').'); // TODO: Verificar/Implementar nova tentativa. Verificar melhor maneira
                  })
              } else {
                console.error('Directions c-' + i + ' request failed due to ' + status);
              }
            });
          _origin = latLng
        })
      }
    },

    renderRoute (route) {
      let find = this.activeRoutes.filter((r) => r.id === route.id)
      if (find.length > 0) {
        console.log(`Route ${route.id} já renderizada`)
        return
      }
      route.render = new this.google.maps.DirectionsRenderer();
      route.render.setMap(this.map)
      const rota = typeof route.rota === 'string' ? JSON.parse(route.rota) : route.rota
      route.render.setDirections(rota);
      route.$checkStatus = setInterval(() => {
        checkRouteStatus(route.id)
          .then((response) => {
            if (!response.data.ativo) {
              // Remove route from map
              this.deleteRoute(route)
            }
          })
          .catch((response) => {
            if (!response.data.ativo) {
              // Remove route from map
              this.deleteRoute(route)
            }
          })
      }, 10000)
      this.activeRoutes.push(route)
    },

    deleteRoute (route) {
      route.render.setMap(null)
      route.$checkStatus && clearInterval(route.$checkStatus)
      this.activeRoutes.splice(this.activeRoutes.indexOf(route), 1);
    },

    // TODO: Move to external
    transition (origin, dest, marker) {
      console.log('MOVE: ', origin, dest)
      transitionIndex = 0;
      deltaLat = (dest.lat - origin.lat) / numDeltas;
      deltaLng = (dest.lng - origin.lng) / numDeltas;
      this.moveMarker(origin, marker);
    },

    moveMarker (origin, marker) {

      origin.lat += deltaLat;
      origin.lng += deltaLng;
      // marker.setTitle('Latitude:' + origin[0] + ' | Longitude:' + origin[1]);
      // marker.setPosition(latlng);
      marker.position = new this.google.maps.LatLng(origin.lat, origin.lng)
      if (transitionIndex != numDeltas) {
        transitionIndex++;
        setTimeout(() => {
          this.moveMarker(origin, marker)
        }, delay);
      }
    },
    focarReboquista ({id}) {
      this.openListaReboques = false
      this.$refs.btnListaReboquistas.toggleButton()
      const found = this.reboquesDisponiveis.find(r => r.id === id)
      if (!found) return
      setTimeout(() => {
        this.focusOnTheSingleMarker(found.marker)
      }, 200)
    }
  }
}
</script>

<template>
  <div class="h-full flex col-grow">
    <div class="google-map" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0"
         ref="googleMap"></div>
    <div :ref="`icon${i.id}`" v-for="i in reboques"></div>
    <map-marker-tooltip ref="mapTooltip"></map-marker-tooltip>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
          :google="google"
          :map="map"
      />
    </template>
    <btn-lista-reboques-map
      ref="btnListaReboquistas"
      @click="openListaReboques = !openListaReboques"
    ></btn-lista-reboques-map>
    <lista-reboques-map
      :opened="openListaReboques"
      :reboquistas="reboquesDisponiveis"
      @focarReboquista="focarReboquista"
    ></lista-reboques-map>
  </div>
</template>

<style scoped>
.custom-marker {
  --size: 35px;

  background-size: cover;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  box-shadow: 2px 2px 2px 0 rgba(0,0,0,0.75);
  -webkit-box-shadow: 2px 2px 2px 0 rgba(0,0,0,0.75);
  -moz-box-shadow: 2px 2px 2px 0 rgba(0,0,0,0.75);
}
.custom-marker-disponivel {
  background-image: url('../assets/img/reboque-disponivel.png');
}
.custom-marker-indisponivel {
  background-image: url('../assets/img/reboque-indisponivel.png');
}
</style>



// WEBPACK FOOTER //
// CallCenterMap.vue?0870a824